import { createAction } from 'redux-actions'
import {
  urlListarIngresosFinanciero, urlListarPreguntasFinanciero, urlListarLimitesFinanciero, urlGuardarCarritoFinanciero, urlConsutlarCarritoFinanciero,
  urlConsutlarCotizadores, urlEnviarCorreoPDFFinanciero, urlConsultarDataResponsabilidad, urlGuardarCarritoResponsabilidadEmpresa, urlConsutlarCarritoResponsabilidadEmpresa,
  urlGuardarCarritoResponsabilidadInstitucion, urlListarProvinciasFinanciero, urlGirosNegocioFinanciero, urlListarIngresosFinancieroCyberEdge
} from "../../constants/urls";

//Listar Limites - Cotizacion Financiero mediate redux-actions
export const listarLimitesFinancieroIsLoading = createAction('LISTAR_LIMITES_FINANCIERO_IS_LOADING');
export const listarLimitesFinancierohasError = createAction('LISTAR_LIMITES_FINANCIERO_HAS_ERROR');
export const setListarLimitesFinanciero = createAction('SET_LISTAR_LIMITES_FINANCIERO');

//Listar Cotizadores - Cotizacion Financiero mediate redux-actions
export const listarCotizadoresIsLoading = createAction('LISTAR_COTIZADORES_IS_LOADING');
export const listarCotizadoreshasError = createAction('LISTAR_COTIZADORES_HAS_ERROR');
export const setListarCotizadores = createAction('SET_LISTAR_COTIZADORES');

//Guardar carrito - Cotizacion Financiero mediate redux-actions
export const guardarCarritoFinancieroIsLoading = createAction('GUARDAR_CARRITO_FINANCIERO_IS_LOADING');
export const guardarCarritoFinancierohasError = createAction('GUARDAR_CARRITO_FINANCIERO_HAS_ERROR');
export const setCarritoFinanciero = createAction('SET_CARRITO_FINANCIERO');

//Consultar carrito - Cotizacion Financiero mediate redux-actions
export const consultarCarritoFinancieroIsLoading = createAction('CONSULTAR_CARRITO_FINANCIERO_IS_LOADING');
export const consultarCarritoFinancierohasError = createAction('CONSULTAR_CARRITO_FINANCIERO_HAS_ERROR');
export const setConsultarCarritoFinanciero = createAction('SET_CONSULTAR_CARRITO_FINANCIERO');

//Enviar al correo PDF- Cotizacion Financiero mediate redux-actions
export const enviarPDFFinancieroIsLoading = createAction('ENVIAR_PDF_FINANCIERO_IS_LOADING');
export const enviarPDFFinancierohasError = createAction('ENVIAR_PDF_FINANCIERO_HAS_ERROR');
export const setEnviarPDFFinanciero = createAction('SET_ENVIAR_PDF_FINANCIERO');

//Listar ingresos, preguntas - Cotizacion Financiero mediate redux-actions
export const FinancierohasError = createAction('DATA_FINANCIERO_HAS_ERROR');
export const FinancieroisLoading = createAction('DATA_FINANCIERO_IS_LOADING');
export const setListarIngresosFinanciero = createAction('SET_LISTAR_INGRESOS_FINANCIERO');
export const setListarIngresosFinancieroEdge = createAction('SET_LISTAR_INGRESOS_FINANCIERO_EDGE');
export const setListarPreguntasFinanciero = createAction('SET_LISTAR_PREGUNTAS_FINANCIERO');
export const setListarProvinciasFinanciero = createAction('SET_LISTAR_PROVINCIAS_FINANCIERO');

//Obtener Data - Cotizacion Responsabilidad mediate redux-actions
export const obtenerDataResponsabilidadIsLoading = createAction('OBTENER_DATA_RESPONSABILIDAD_IS_LOADING');
export const obtenerDataResponsabilidadhasError = createAction('OBTENER_DATA_RESPONSABILIDAD_HAS_ERROR');
export const setObtenerDataResponsabilidad = createAction('SET_OBTENER_DATA_RESPONSABILIDAD');

//Consultar Provincias - Cotizacion Responsabilidad mediate redux-actions
export const listarProvinciasResponsabilidadIsLoading = createAction('LISTAR_PROVINCIAS_RESPONSABILIDAD_IS_LOADING');
export const listarProvinciasResponsabilidadhasError = createAction('LISTAR_PROVINCIAS_RESPONSABILIDAD_HAS_ERROR');
export const setListarProvinciasResponsabilidad = createAction('SET_LISTAR_PROVINCIAS_RESPONSABILIDAD');


//Guardar carrito - Cotizacion Responsabilidad mediate redux-actions
export const guardarCarritoResponsabilidadIsLoading = createAction('GUARDAR_CARRITO_RESPONSABILIDAD_IS_LOADING');
export const guardarCarritoResponsabilidadhasError = createAction('GUARDAR_CARRITO_RESPONSABILIDAD_HAS_ERROR');
export const setCarritoResponsabilidad = createAction('SET_CARRITO_RESPONSABILIDAD');

//Consultar carrito - Cotizacion Responsabilidad mediate redux-actions
export const consultarCarritoResponsabilidadIsLoading = createAction('CONSULTAR_CARRITO_RESPONSABILIDAD_IS_LOADING');
export const consultarCarritoResponsabilidadhasError = createAction('CONSULTAR_CARRITO_RESPONSABILIDAD_HAS_ERROR');
export const setConsultarCarritoResponsabilidad = createAction('SET_CONSULTAR_CARRITO_RESPONSABILIDAD');

//Giro de Negocios - Cotizacion Lineas Financieras mediate redux-actions
export const girosNegocioFinancieroIsLoading = createAction('GIROS_NEGOCIO_FINANCIERRO_IS_LOADING');
export const girosNegocioFinancierohasError = createAction('GIROS_NEGOCIO_FINANCIERRO_HAS_ERROR');
export const setGirosNegocioFinanciero = createAction('SET_GIROS_NEGOCIO_FINANCIERRO');

/**
 * 
 * @param {string} codProducto Id del producto a consultar
 * @returns {void}
 * Obtener información para utilizar en el cotizador financiero Cyber Edge
 */
export const fetchDataCyberEdge = codProducto => async dispatch => {
  dispatch(FinancieroisLoading());
  await fetch(`${urlListarIngresosFinancieroCyberEdge}${codProducto}`)
    .then(response => response.json())
    .then(data => {
      if (data.transaccion) {
        let ingresos = data.data;

        dispatch(setListarIngresosFinancieroEdge(ingresos));
      } else {
        dispatch(FinancierohasError('Error al devolver datos, ingresos'))
        return
      }
    })
    .catch((e) => {
      console.log(e)
      dispatch(FinancierohasError('Error al consultar servicio, ingresos'));
      return
    });

}

/**
 * 
 * @param {string} codProducto Id del producto a consultar
 * @returns {void}
 * Obtener información para utilizar en el cotizador financiero
 */
export const fetchDataFinanciero = codProducto => async dispatch => {
  dispatch(FinancieroisLoading());
  await fetch(`${urlListarIngresosFinanciero}${codProducto}`)
    .then(response => response.json())
    .then(data => {
      if (data.transaccion) {
        let ingresos = data.lista;
        let arrayIngresos = [];
        if (ingresos.length > 0) {
          ingresos.forEach(element => {
            const elemento = {
              id: element.ingCodigoCore,
              name: element.ingDescripcion
            }
            arrayIngresos.push(elemento)
          });
        }
        dispatch(setListarIngresosFinanciero(arrayIngresos));
      } else {
        dispatch(FinancierohasError('Error al devolver datos, ingresos'))
        return
      }
    })
    .catch((e) => {
      console.log(e)
      dispatch(FinancierohasError('Error al consultar servicio, ingresos'));
      return
    });

  dispatch(FinancieroisLoading());
  await fetch(`${urlListarPreguntasFinanciero}${codProducto}`)
    .then(response => response.json())
    .then(data => {
      let arrayPreguntas = [];
      if (data.transaccion) {
        arrayPreguntas = data.lista;
        dispatch(setListarPreguntasFinanciero(arrayPreguntas));
      } else {
        dispatch(FinancierohasError('Error al devolver datos, estatus'));
        dispatch(setListarPreguntasFinanciero(arrayPreguntas));
        return
      }
    })
    .catch((e) => {
      console.log(e)
      dispatch(FinancierohasError('Error al consultar servicio, estatus'));
      return
    });

  dispatch(FinancieroisLoading());
  await fetch(`${urlListarProvinciasFinanciero}`)
    .then(response => response.json())
    .then(data => {
      let arrayProvincias = [];
      if (data.transaccion) {
        let provincias = data.provincias;
        if (provincias.length > 1)
          provincias.forEach(element => {
            const elemento = {
              value: element.provCodigoCore,
              label: element.provNombre,
              id: element.id,
              paiCodigoCore: element.paiCodigoCore
            }
            arrayProvincias.push(elemento)
          });
        dispatch(setListarProvinciasFinanciero(arrayProvincias));
      } else {
        dispatch(FinancierohasError('Error al devolver datos, provincias'));
        dispatch(setListarProvinciasFinanciero(arrayProvincias));
        return
      }
    })
    .catch((e) => {
      console.log(e)
      dispatch(FinancierohasError('Error al consultar servicio, provincias'));
      return
    });




};



/**
* 
* @param {string} codProducto Id del producto a consultar
* @param {string}codIngreso Código del producto a consultar
* @returns {void}
* Obtener límites para utilizar en el cotizador financiero
*/
export const fetchListarLimitesFinanciero = (codProducto, codIngreso) => {
  var url = `${urlListarLimitesFinanciero}${codProducto}&codigoIngreso=${codIngreso}`;
  return async dispatch => {
    dispatch(listarLimitesFinancieroIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let arrayLimites = [];
          arrayLimites = data;
          dispatch(setListarLimitesFinanciero(arrayLimites));
        } else {
          dispatch(listarLimitesFinancierohasError());
        }
      })
      .catch(() => {
        dispatch(listarLimitesFinancierohasError());
      });
  };
};
//Listar Cotizadores - Cotizacion Financiero
export const fetchListarCotizadores = (dato) => async dispatch => {
  var url = `${urlConsutlarCotizadores}${dato}`;
  dispatch(listarCotizadoresIsLoading());
  await fetch(url)
    .then(response => response.json())
    .then(data => {
      if (data.transaccion) {
        let arrayCotizadores = [];
        arrayCotizadores = data.listaSeguros;

        if (arrayCotizadores.length > 0)
          arrayCotizadores.sort(function (a, b) {
            if (a.segNombre > b.segNombre) return 1;
            if (b.segNombre > a.segNombre) return -1;
            return 0;
          });
        dispatch(setListarCotizadores(arrayCotizadores));
      } else {
        dispatch(listarCotizadoreshasError());
      }
    })
    .catch(() => {
      dispatch(listarCotizadoreshasError());
    });

};


/**
 * 
 * @param {Object} param  Trama con los datos de la nueva poliza
 * @returns {void}
 * Guarda la poliza de seguros 
 */
export const fetchGuardarCarritoFinanciero = param => async dispatch => {
  var url = `${urlGuardarCarritoFinanciero}`;
  dispatch(guardarCarritoFinancieroIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {

      console.log('verData: ', data)
      let carritoFinanciero = {};
      if (data.transaccion) {
        carritoFinanciero = data;
        dispatch(setCarritoFinanciero(carritoFinanciero));
      } else {
        dispatch(guardarCarritoFinancierohasError());
        carritoFinanciero = data;
        dispatch(setCarritoFinanciero(carritoFinanciero));
      }
    })
    .catch(() => {
      dispatch(guardarCarritoFinancierohasError());
    });
};


/**
 * 
 * @param {Object} datos  id del carrito a consultar
 * @returns {void}
 * Obtener la poliza de seguros 
 */
export const fetchConsultarCarritoFinanciero = (datos) => {
  var url = `${urlConsutlarCarritoFinanciero}${datos}`;
  return async dispatch => {
    dispatch(consultarCarritoFinancieroIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        let arrayCarrito = {};
        if (data.transaccion) {
          arrayCarrito = data;
          dispatch(setConsultarCarritoFinanciero(arrayCarrito));
        } else {
          dispatch(consultarCarritoFinancierohasError());
          dispatch(setConsultarCarritoFinanciero(arrayCarrito));
        }
      })
      .catch(() => {
        dispatch(consultarCarritoFinancierohasError());
      });
  };
};

//Enviar Correo PDF - Cotizacion Financiero
export const fetchEnviarPDFFinanciero = (Data) => {
  var url = `${urlEnviarCorreoPDFFinanciero}${Data}`;
  return async dispatch => {
    dispatch(enviarPDFFinancieroIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let arrayDatos = [];
          arrayDatos = data;
          dispatch(setEnviarPDFFinanciero(arrayDatos));
        } else {
          dispatch(enviarPDFFinancierohasError());
        }
      })
      .catch(() => {
        dispatch(enviarPDFFinancierohasError());
      });
  };
};


//Obtiene datos - Cotizacion Responsabilidad
export const fetchObtenerDataResponsabilidad = param => async dispatch => {
  var url = `${urlConsultarDataResponsabilidad}`;
  dispatch(obtenerDataResponsabilidadIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      if (data.transaccion) {
        if (data.arrayCombosEmpresa) {
          //
          let actividades = data.arrayCombosEmpresa.actividad;
          let arrayActividades = [];
          if (actividades.length > 1)
            actividades.forEach(element => {
              const elemento = {
                value: element.id,
                label: element.value,
              }
              arrayActividades.push(elemento)
            });
          //
          let facturacion = data.arrayCombosEmpresa.facturacion;
          let arrayFacturacion = [];
          if (facturacion.length > 1)
            arrayFacturacion.push({ id: "", name: "Seleccione un valor" })
          facturacion.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayFacturacion.push(elemento)
          });

          //
          let limite = data.arrayCombosEmpresa.limite;
          let arrayLimites = [];
          if (limite.length > 1)
            arrayLimites.push({ id: "", name: "Seleccione un valor" })
          limite.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayLimites.push(elemento)
          });

          const datosEmpresa = {
            selectActividades: arrayActividades,
            selectFacturacion: arrayFacturacion,
            selectLimites: arrayLimites
          }
          dispatch(setObtenerDataResponsabilidad(datosEmpresa));
        } else if (data.arrayCombosInstitucion) {
          //
          let nivelAcademico = data.arrayCombosInstitucion.nivelAcademico;
          let arrayNivelAcademico = [];
          if (nivelAcademico.length > 1)
            arrayNivelAcademico.push({ id: "", name: "Seleccione un Nivel Académico" })
          nivelAcademico.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayNivelAcademico.push(elemento)
          });
          //
          let facturacion = data.arrayCombosInstitucion.facturacion;
          let arrayFacturacion = [];
          if (facturacion.length > 1)
            arrayFacturacion.push({ id: "", name: "Seleccione un valor" })
          facturacion.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayFacturacion.push(elemento)
          });

          //
          let tipoInstitucion = data.arrayCombosInstitucion.tipoInstitucion;
          let arrayTipoInstitucion = [];
          if (tipoInstitucion.length > 1)
            arrayTipoInstitucion.push({ id: "", name: "Seleccione un Tipo de Institución" })
          tipoInstitucion.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayTipoInstitucion.push(elemento)
          });
          //
          let numEstudiantes = data.arrayCombosInstitucion.numEstudiantes;
          let arrayNumEstudiantes = [];
          if (numEstudiantes.length > 1)
            arrayNumEstudiantes.push({ id: "", name: "Seleccione el Número de Estudiantes" })
          numEstudiantes.forEach(element => {
            const elemento = {
              id: element.id,
              name: element.value,
            }
            arrayNumEstudiantes.push(elemento)
          });

          const datosInstitucion = {
            selectNivelAcademico: arrayNivelAcademico,
            selectFacturacion: arrayFacturacion,
            selectTipoInstitucion: arrayTipoInstitucion,
            selectNumEstudiantes: arrayNumEstudiantes,
          }
          dispatch(setObtenerDataResponsabilidad(datosInstitucion));
        }

      } else {
        dispatch(obtenerDataResponsabilidadhasError());
      }
    })
    .catch(() => {
      dispatch(obtenerDataResponsabilidadhasError());
    });
};

//Listar Provincias - Cotizacion Responsabilidad

export const fetchListarProvinciasResponsabilidad = () => {

  var url = `${urlListarProvinciasFinanciero}`;
  return async dispatch => {
    dispatch(listarProvinciasResponsabilidadIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let provincias = data.provincias;
          let arrayProvincias = [];
          if (provincias.length > 1)
            provincias.forEach(element => {
              const elemento = {
                value: element.provCodigoCore,
                label: element.provNombre,
                id: element.id,
                paiCodigoCore: element.paiCodigoCore
              }
              arrayProvincias.push(elemento)
            });
          dispatch(setListarProvinciasResponsabilidad(arrayProvincias));
        } else {
          dispatch(listarProvinciasResponsabilidadhasError());
        }
      })
      .catch(() => {
        dispatch(listarProvinciasResponsabilidadhasError());
      });
  };
};


//Guardar Carrito - Cotizacion Responsabilidad
export const fetchGuardarCarritoResponsabilidad = param => async dispatch => {
  var url = '';
  if (param.areaCotizador === "empresa")
    url = `${urlGuardarCarritoResponsabilidadEmpresa}`;
  else if (param.areaCotizador === "institucion")
    url = `${urlGuardarCarritoResponsabilidadInstitucion}`;


  dispatch(guardarCarritoResponsabilidadIsLoading());
  await fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json"
    },
    body: JSON.stringify(param)
  })
    .then(response => response.json())
    .then(data => {
      let carritoFinanciero = {};
      if (data.transaccion) {
        carritoFinanciero = data;
        dispatch(setCarritoResponsabilidad(carritoFinanciero));
      } else {
        dispatch(guardarCarritoResponsabilidadhasError());
        carritoFinanciero = data;
        dispatch(setCarritoResponsabilidad(carritoFinanciero));
      }
    })
    .catch(() => {
      dispatch(guardarCarritoResponsabilidadhasError());
    });
};

//Consultar carrito - Cotizacion Responsabilidad
export const fetchConsultarCarritoResponsabilidad = (datos) => {
  var url = `${urlConsutlarCarritoResponsabilidadEmpresa}${datos}`;
  return async dispatch => {
    dispatch(consultarCarritoResponsabilidadIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        let arrayCarrito = {};
        if (data.transaccion) {
          arrayCarrito = data;

          if (arrayCarrito.selectDeducible) {
            arrayCarrito.selectDeducible.unshift({ id: "", name: "Seleccione un valor" })
          }
          if (arrayCarrito.selectAmparos) {
            arrayCarrito.selectAmparos[0].detalle.unshift({ id: "", name: "Seleccione un valor" })
            //arrayCarrito.selectAmparos[1].detalle.unshift({ id: "", name: "Seleccione un valor" })//Comentado para no permitir seleecionar un valor Responsabilidad CIvil
          }
          if (arrayCarrito.selectLimites) {
            arrayCarrito.selectLimites.unshift({ id: "", name: "Seleccione un valor" })
          }
          dispatch(setConsultarCarritoResponsabilidad(arrayCarrito));
        } else {
          dispatch(consultarCarritoResponsabilidadhasError());
          dispatch(setConsultarCarritoResponsabilidad(arrayCarrito));
        }
      })
      .catch(() => {
        dispatch(consultarCarritoResponsabilidadhasError());
      });
  };
};

//Giro de Negocios  - Cotizacion Lineas Financieras
export const fetchGirosNegocioFinanciero = () => {
  var url = `${urlGirosNegocioFinanciero}`;
  return async dispatch => {
    dispatch(girosNegocioFinancieroIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let arrayGiros = {};
          arrayGiros = data.listaGiroNegocio;
          dispatch(setGirosNegocioFinanciero(arrayGiros));
        } else {
          dispatch(girosNegocioFinancierohasError());
        }
      })
      .catch(() => {
        dispatch(girosNegocioFinancierohasError());
      });
  };
};

export const fetchGirosNegocioFinanciero2 = (prod) => {
  var url = `${urlGirosNegocioFinanciero}&idproducto=${prod}`;
  return async dispatch => {
    dispatch(girosNegocioFinancieroIsLoading());
    await fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data.transaccion) {
          let arrayGiros = {};
          arrayGiros = data.listaGiroNegocio;
          dispatch(setGirosNegocioFinanciero(arrayGiros));
        } else {
          dispatch(girosNegocioFinancierohasError());
        }
      })
      .catch(() => {
        dispatch(girosNegocioFinancierohasError());
      });
  };
};

